<script lang="ts">
	export let text: string;
</script>

<th scope="col" class="cell-header text-left">
	{text}
</th>

<style>
	.cell-header {
		/* display: flex; */
		padding: 16px;
		align-items: center;
		flex: 1 0 0;
		color: var(--gray-70, #6b6b6b);

		/* body-EB-05 */
		font-size: 14px;
		font-family: Lato;
		font-style: normal;
		font-weight: 800;
	}
</style>
